"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    connectWith: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    draggable: {
        type: [Boolean, Object],
        default: undefined
    },
    dropSources: {
        type: Array,
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    selectable: {
        type: String,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    toolbar: {
        type: Object,
        default: undefined
    },

    // Events
    add: Function,
    change: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    dragstart: Function,
    drag: Function,
    drop: Function,
    dragend: Function,
    remove: Function,
    reorder: Function
};